import React from "react";
import AddActor from "./AddActor"
import AddZwrotAkcji from "./AddZwrotAkcji"
import AddPytanie from './AddPytanie'
import './AddTekst.css'


class AddTekst extends React.Component {
  render() {
    return (
        <div className="add-tekst">
            <AddActor  />
            <AddZwrotAkcji  />
            <AddPytanie />
        </div>
    );
  }
}

export default AddTekst;
